module.exports = __webpack_public_path__ + "img/Hefty-Commissions-94x94.6e89ea9.png";